(function() {
  'use strict';
  angular.module('benefits')
  .filter('otherLimitations', function() {
    var getDuration = function (length, unit) {
      if (length && unit) {
        return length === 1 && unit.toLowerCase() === 'lifetime'  ? 'Lifetime' : ( length + " " + unit );
      }
    };
    return function(limitations, benefitInfo) {
      var returnText = [];
      if (limitations.limitedToTeeth && limitations.limitedToTeeth.length > 0) {
        returnText.push("Limited to teeth " + (angular.isArray(limitations.limitedToTeeth) ? limitations.limitedToTeeth.join(", ") : limitations.limitedToTeeth));
      }
      if (limitations.missingToothProvision) {
        if (limitations.missingToothProvision.applies) {
          var duration = getDuration(limitations.missingToothProvision.length, limitations.missingToothProvision.unit);
          returnText.push( duration && limitations.missingToothProvision.length !== 999 ? 
            "Missing Tooth Provision: " + duration : 
            "Missing Tooth Provision applies" );
        } else {
          if (limitations.missingToothProvision.applies === null) {
              returnText.push("<span class='text-warning'>Policy may have a Missing Tooth Provision</span>");
          }
        }
      }
      return returnText;
    };
  });
})();
